import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'

const index = resolve => require(['@/views/index/index'], resolve);

function path(path, name, requireAuth, trade, other = {}, children = [], redirect) {
  return Object.assign({
    path: `/${path}`,
    name: path,
    redirect,
    meta: {
      requireAuth,
      trade
    },
    component: resolve => require(['@/views/' + name], resolve),
    children,
    props: func,
  }, other)
}

Vue.use(Router);
Router.prototype.xHistory = [];

function func({sendDatas, query}) {
  return {
    ...sendDatas,
    ...query
  };
}

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      component: index,
    },
    // pages
    path('login', 'login/login'),
    path('userNameLogin', 'login/userNameLogin'),
    path('register1', 'login/register1'),
    path('register2', 'login/register2'),
    path('findPassword', 'login/findPassword'),

    /*首页相关开始*/
    path('announceDetail', 'index/announceDetail', true),
    path('announcement', 'index/announcement', true),
    path('anounceList', 'index/anounceList'),
    path('anounceDetail', 'index/anounceDetail', true),
    path('recommendation', 'index/recommendation'),
    path('infoDetail', 'index/infoDetail',),
    path('originalDetail', 'index/originalDetail', true),
    path('contactUs', 'index/contactUs'),//联系我们
    path('rule', 'index/rule' ),//交易规则
    path('safe', 'index/safe' ),//安全保障
    path('about', 'index/about'),//关于我们
    /*首页相关结束*/

    /*自选相关开始*/
    path('optional', 'optional/optional', true),
    path('emitOptional', 'optional/emitOptional', true),
    path('search', 'optional/search'),
    path('industyFund', 'optional/industyFund', true),
    path('conceptFund', 'optional/conceptFund', true),
    path('individual', 'optional/individual', true),
    path('industry', 'optional/industry', true),
    path('performer', 'optional/performer', true),
    path('DropList', 'optional/DropList', true),
    path('turnoverList', 'optional/turnoverList', true),
    path('fivePerformer', 'optional/fivePerformer', true),
    path('fiveDropList', 'optional/fiveDropList', true),
    path('volumeList', 'optional/volumeList', true),

    /*自选相关结束*/

    /*交易相关开始*/
    path('deal/:id/:step', 'deal/deal', true),
    path('trade/:id/:step', 'deal/trade', true),
    path('sellDetail', 'deal/sellDetail', true),
    path('settleDetail', 'deal/settleDetail', true),
    path('cheekAgreement', 'deal/cheekAgreement', true),
    path('buy', 'deal/buy', true),
    path('simpleLine', 'deal/simpleLine', true),
    path('researchReportDetail', 'deal/researchReportDetail', true),//研报详情
    path('stockNoticeDetail', 'deal/stockNoticeDetail', true),//公告详情
    // path('match', 'deal/match', true),
    path('matchseccess', 'deal/matchseccess', true),
    /*交易相关结束*/

    /*发现相关开始*/
    path('find', 'find/find', true),
    path('allBuy', 'find/allBuy', true),
    path('activeCenter', 'find/activeCenter', true),
    path('masterList', 'find/masterList', true),
    path('mySubscribe', 'find/mySubscribe', true),
    path('subscribeDetails', 'find/subscribeDetails', true),
    path('winnersList', 'find/winnersList', true),
    path('winnersDetails', 'find/winnersDetails', true),

    /*发现相关结束*/

    /*my相关开始*/
    path('my', 'my/my', true),
    path('agreement', 'my/agreement', true),
    path('detailed', 'my/detailed', true),
    path('invite', 'my/invite', true),
    path('strategy', 'my/strategy', true),
    path('agreementDetaile', 'my/agreementDetaile', true),
    path('myIntegral', 'my/myIntegral', true),
    path('exchange', 'my/exchange', true),
    path('task', 'my/task'),
    path('coupon', 'my/coupon', true),
    path('historyCoupon', 'my/historyCoupon', true),
    path('myrule', 'my/rule', true),
    path('myMessage', 'my/myMessage', true),
    path('setUp', 'my/setUp', true),
    path('changePhone', 'my/changePhone', true),
    path('authentication', 'my/authentication', true),
    path('myBank', 'my/myBank', true),
    path('addCard', 'my/addCard', true),
    path('modifyPassword', 'my/modifyPassword', true),
    path('presentationPassword', 'my/presentationPassword', true),
    path('retrievePassword', 'my/retrievePassword', true),
    path('toRecharge', 'my/toRecharge',true),
    path('quickpay', 'my/quickpay',true),
    path('quickpayNext', 'my/quickpayNext',true),
    path('alipay', 'my/alipay',true),
    path('alipayDetail', 'my/alipayDetail',true),
    path('cashWithdrawal', 'my/cashWithdrawal',true),
    path('selectCard', 'my/selectCard',true),
    path('personal', 'my/personal',true),
    path('updateName', 'my/updateName',true),
    path('setpassword', 'my/setpassword',true),
    path('beginners', 'my/beginners'),
    path('beginnersDetail', 'my/beginnersDetail',true),
    path('myAlipay', 'my/myAlipay',true),
    path('bankWithdrawal', 'my/bankWithdrawal',true),
    path('bankDetail', 'my/bankDetail',true),
    /*my相关结束*/

    /*50ETF自选相关开始*/
    path('transact', 'etf/deal/transact',true),//行情
    path('transactionDetails', 'etf/deal/transactionDetails',true),
    path('etfselfOptional', 'etf/optional/etfSelfOptional',true),//50etf自选
    path('etfsearch', 'etf/optional/etfSearch',true),//50etf自选搜索
    path('etfEmitOptional', 'etf/optional/etfEmitOptional',true),////50etf编辑自选
    /*50ETF自选相关结束*/
    /*50ETf行情相关开始*/
    path('etfQuotation', 'etf/deal/etfQuotation',true),//50etf行情首页
    path('assets', 'etf/deal/assets',true),//50etf行情资产
    path('subscription', 'etf/deal/subscription',true),//50etf行情认购
    path('transaction/:id/:step', 'etf/deal/transaction', true),//交易
    path('etfbuy', 'etf/deal/etfbuy', true),//50etf买入/卖出
    path('etfMonibuy', 'etf/deal/etfMonibuy', true),//50etf模拟买入/卖出
    path('dangerous', 'etf/deal/dangerous', true),//50etf风险书详情
    path('cancelOrder', 'etf/deal/cancelOrder', true),//50etf撤单
    path('seach', 'etf/optional/seach',true),//50etf搜索股票
    // /*50ETF行情相关结束*/
    /*风险评测开始*/
    path('risk', 'index/risk',true),//风险评测首页
    path('riskStart', 'index/riskDetail', true),//风险评测题目
    path('results', 'index/results', true),//风险评测题目
    /*风险评测结束*/
    /*科创开始*/
    path('kcQuotation', 'kc/kcQuotation', true),//科创行情
    /*科创结束*/
  ]
});

router.beforeEach((to, from, next) => {
  clearInterval(window._getOptional);
  clearInterval(window.currentTime);
  const TOKEN = window.localStorage.getItem('uuid') || '';
  if (to.meta.requireAuth) {
    if (TOKEN) {
      next()
    } else {
      // next()
     next({
        path: '/login',
        query: {redirect: to.path}
      })
    }
  } else {
    next()
  }
});
router.afterEach((to, from) => {
  if (to.path == from.path) {
    router.transitionName = '';
  } else {
    if (router.xHistory.length >= 3) {
      router.xHistory.shift();
      router.xHistory.shift();
    }
    router.xHistory.push(to.path);
    if (router.xHistory[0] == router.xHistory[2]) {
      router.transitionName = 'route-back';
    } else {
      router.transitionName = 'route-forward';
    }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js